/**
 * Created by daniel on 11/04/17.
 */
import React, { Component } from 'react';
import {connect} from 'react-redux';
import Canvas from './Canvas'
import ContentContainer from "../ContentContainer";
import {getRootItem} from "../../state/content/selectors";

class CanvasContainer extends Component {
  constructor(props) {
    super(props);
  
    if (!this.props.rootItem) {
      //this.props.dispatch(createContentItem(null, null, "ROOT_ITEM", getContentDefinitions(this.props.state)));
    }
  }
  // Find the active states root element and render this to the canvas
  render() {
    return (
      <Canvas>
        {this.props.rootItem && <ContentContainer contentId={this.props.rootItem.contentId} key={this.props.rootItem.contentId} />}
      </Canvas>
    );
  }
}

const mapStateToProps = (state) => {
  let rootItem = getRootItem(state);
  return {
    rootItem,
    state,
  };
};

export default connect(mapStateToProps)(CanvasContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/CanvasContainer.js